import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { ModeActionTypes, ModeActions } from "../../../actionTypes/master/modeActionTypes";
import { createModeApi, editModeDataByIdApi, getModeDataByIdApi, getModeListApi } from "../../requests/master/modeRequests";
import { getModeList, setModeDataById, setModeList, setModeListPageCount } from "../../../actions/master/modeAction";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* getModeListHandler(action: ModeActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getModeListApi, action.payload);
    if (data.status) {
      yield put(setModeList(data?.data?.rows));
      yield put(setModeListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* createModeHandler(action: ModeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createModeApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getModeDataByIdHandler(action: ModeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getModeDataByIdApi, action.payload);
    if (data.status) {
      yield put(setModeDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}
function* editModeDataByIdHandler(action: ModeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editModeDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getModeList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// mode sagas
export default function* modeSaga() {
  yield takeLatest(ModeActions.GET_MODE_LIST, getModeListHandler);
  yield takeLatest(ModeActions.CREATE_MODE, createModeHandler);
  yield takeLatest(ModeActions.GET_MODE_DATA_BY_ID, getModeDataByIdHandler);
  yield takeLatest(ModeActions.EDIT_MODE_DATA_BY_ID, editModeDataByIdHandler);
}
